<template>
    <span class="value-missing text-200">{{ $t('§ui.value_missing') }}</span>
</template>

<script>
export default {
    name: 'CoreValueMissing',
}
</script>

<style>
.value-missing {
    color: var(--color-secondary-200);
}
</style>
